/** 
 * Learn more about theme events at
 * https://help.switchthemes.co/shapes/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.0',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('shapes:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.dispatchEvent(
        new CustomEvent('shapes:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('cart-will-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail,
    })
  );
});

document.addEventListener('cart-is-open', async () => {
  const cartDrawerEl = getCartDrawerEl();

  const detail = {
    cartDrawerEl,
  };

  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail,
    })
  );
});

document.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cart_type === 'modal' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);
document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}

(function (globalScope, factory) {
  const api = factory(globalScope);

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (globalScope) {
    globalScope.TIENegativeCartGuard = api;
  }

  if (globalScope && globalScope.document && globalScope.fetch) {
    api.init();
  }
})(typeof window !== 'undefined' ? window : globalThis, function (globalScope) {
  'use strict';

  const ELIGIBLE_HANDLES = new Set([
    'colour-c41-film-developing-inc-disposables',
    'black-and-white-film-developing',
    'ecn-2-film-developing',
    'e6-slide-film-developing',
  ]);

  const DISPOSE_VALUE = 'Dispose of negatives';
  const RETURN_VALUE = 'Return negatives';

  const normalise = (value) => String(value || '').toLowerCase().trim();

  const isEligibleDevelopingItem = (item) =>
    Boolean(item && ELIGIBLE_HANDLES.has(normalise(item.handle)));

  const isPhysicalBlocker = (item) =>
    Boolean(item && item.requires_shipping) && !isEligibleDevelopingItem(item);

  const getVariantOptions = (item) =>
    Array.isArray(item && item.variant_options) ? item.variant_options : [];

  const isDevelopOnly = (item) => {
    const options = getVariantOptions(item);

    return (
      normalise(options[0]).includes('develop only') ||
      normalise(item && item.variant_title).includes('develop only')
    );
  };

  const hasPrints = (item) => {
    const options = getVariantOptions(item);

    if (options.length < 3) return false;

    const printValue = normalise(options[2]);
    return Boolean(printValue) && printValue !== 'no prints';
  };

  const removeHandlingProperties = (properties) => {
    const next = { ...(properties || {}) };
    delete next['Negative Handling'];
    delete next['Negative handling'];
    return next;
  };

  const sameProperties = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  const lineForcesReturn = (item) => {
    const properties = item && item.properties ? item.properties : {};

    return (
      properties['Negative return'] === RETURN_VALUE ||
      isDevelopOnly(item) ||
      hasPrints(item)
    );
  };

  const planNegativeCartChanges = (cart) => {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const eligibleItems = items.filter(isEligibleDevelopingItem);
    const hasPhysicalBlocker = items.some(isPhysicalBlocker);
    const mustReturnEverything =
      hasPhysicalBlocker || eligibleItems.some(lineForcesReturn);
    const changes = [];

    eligibleItems.forEach((item) => {
      const properties = { ...(item.properties || {}) };
      const currentReturn = properties['Negative return'] || '';
      let nextProperties = { ...properties };

      if (mustReturnEverything) {
        if (currentReturn === DISPOSE_VALUE) {
          nextProperties = removeHandlingProperties(nextProperties);
        }

        if (currentReturn !== RETURN_VALUE) {
          nextProperties['Negative return'] = RETURN_VALUE;
        }
      } else if (currentReturn === DISPOSE_VALUE) {
        nextProperties = removeHandlingProperties(nextProperties);
      }

      if (!sameProperties(nextProperties, properties)) {
        changes.push({
          key: item.key,
          quantity: item.quantity,
          properties: nextProperties,
        });
      }
    });

    return changes;
  };

  let activeSync = null;
  let rerunRequested = false;
  let refreshRequested = false;
  let initialised = false;

  const routesRoot = () => {
    const root =
      globalScope &&
      globalScope.Shopify &&
      globalScope.Shopify.routes &&
      globalScope.Shopify.routes.root;

    return root || '/';
  };

  const fetchCart = async () => {
    const response = await globalScope.fetch(`${routesRoot()}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Could not read cart (${response.status})`);
    }

    return response.json();
  };

  const updateLineProperties = async (change) => {
    const response = await globalScope.fetch(`${routesRoot()}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: change.key,
        quantity: change.quantity,
        properties: change.properties,
      }),
    });

    if (!response.ok) {
      throw new Error(`Could not update cart line (${response.status})`);
    }

    return response.json();
  };

  const showCartError = (message) => {
    const errorBox = globalScope.document.getElementById('cart-errors');
    if (errorBox) errorBox.textContent = message;
  };

  const syncCart = async ({ refresh = true } = {}) => {
    rerunRequested = true;
    refreshRequested = refreshRequested || refresh;

    if (activeSync) return activeSync;

    activeSync = (async () => {
      let anyChanged = false;
      let shouldRefresh = false;

      try {
        while (rerunRequested) {
          rerunRequested = false;
          shouldRefresh = shouldRefresh || refreshRequested;
          refreshRequested = false;

          const cart = await fetchCart();
          const changes = planNegativeCartChanges(cart);

          for (const change of changes) {
            await updateLineProperties(change);
            anyChanged = true;
          }
        }

        if (anyChanged && shouldRefresh) {
          globalScope.document.dispatchEvent(
            new CustomEvent('theme:update:cart')
          );
        }

        return { ok: true, changed: anyChanged };
      } catch (error) {
        console.error('Take It Easy negative return cart guard:', error);
        showCartError(
          'We could not confirm your negative return preference. Please try again before checkout.'
        );
        return { ok: false, changed: anyChanged, error };
      } finally {
        activeSync = null;
      }
    })();

    return activeSync;
  };

  const isCheckoutSubmit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart') return false;

    const submitter = event.submitter;
    return Boolean(submitter && submitter.name === 'checkout');
  };

  const handleCheckoutSubmit = async (event) => {
    if (!isCheckoutSubmit(event)) return;

    const form = event.target;
    if (form.dataset.negativeGuardBypass === 'true') return;

    event.preventDefault();

    const submitter = event.submitter;
    const result = await syncCart({ refresh: false });
    if (!result.ok) return;

    form.dataset.negativeGuardBypass = 'true';

    try {
      form.requestSubmit(submitter);
    } finally {
      setTimeout(() => {
        delete form.dataset.negativeGuardBypass;
      }, 0);
    }
  };

  const queueSync = () => {
    syncCart({ refresh: true });
  };

  const init = () => {
    if (initialised || !globalScope.document) return;
    initialised = true;

    globalScope.document.addEventListener('theme:cart:change', queueSync);
    globalScope.document.addEventListener('shapes:cart:afteradditem', queueSync);
    globalScope.document.addEventListener('theme:cart-drawer:opening', queueSync);
    globalScope.document.addEventListener('submit', handleCheckoutSubmit, true);

    if (globalScope.document.readyState === 'loading') {
      globalScope.document.addEventListener(
        'DOMContentLoaded',
        () => syncCart({ refresh: true }),
        { once: true }
      );
    } else {
      syncCart({ refresh: true });
    }
  };

  return {
    init,
    isEligibleDevelopingItem,
    isDevelopOnly,
    hasPrints,
    planNegativeCartChanges,
    syncCart,
  };
});
